import { useQuery } from 'react-query'
import { axiosInstance, baseURL } from './auth'

// export const addPatients = async (params) => {
//     try {
//         const response = await axiosInstance.post(`${baseURL}/patient/add`, params);
//         return response.data;
//     } catch (error) {
//         throw new Error(error.response.data.errors.message);
//     }
// };

export const addPatients = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/add`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getListPatients = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// export const getListPatients = async (params) => {
//         const response = await axiosInstance.post(`${baseURL}/patient/list`, params);
// if (response.data.status_code !== 200) {
//     throw new Error(response.data.errors.message)
// }
// return response.data
//
// };

// EXport Patient List

export const ExportPatientList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/exportPatientExcel`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

//  Download Sample

export const DownloadPatientSample = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/sheet`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

//  Import Patinet List

export const ImportPatient = async (params, file) => {
    const response = await axiosInstance.post(`${baseURL}/patient/upload/excel/sheet/${params}`, file)
    if (response.data.status_code !== 200) {
        // let newArr = []
        if (response.data.errors[0].message) {
            // newArr.push(response.data.errors[0].message)
        }
        // else if (response.data.errors[0].error.length > 0) {
        //     response.data.errors[0].error.forEach((element, i) => {
        //         newArr[i] = element.name ? element.name : element.message
        //     });
        // }
        throw new Error(response.data.errors[0].message)
    }
    return response.data
}

export const getPatientFilterList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/without_pagination_list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const UpDatePatient = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/patient/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const getPatientsViewById = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/patient/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// E_Prescription
export const getE_PrescriptionList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/e_priscription/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

//notes
export const getNoteTypeList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/note_type/filter_list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const addNote = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/notes`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getNoteList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/notes/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// form shared
export const getFormSharedList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/filled_dynamic_form/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const getFormSharedById = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/filled_dynamic_form/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const UpdateFillForm = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/filled_dynamic_form`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// form history
export const getFormHistoryList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/filled_dynamic_form/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// insurance

export const addInsurance = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/add`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const getInsuranceList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/list`, params)
    // if (response.data.status_code !== 200) {
    //     throw new Error(response.data.errors.message)
    // }
    return response.data
}
export const updateInsurance = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/insurance/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
//  HMO in Insurance section
export const addHOM = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/hmo/add`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const getHOMList = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/insurance/hmo/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const HMOUpdate = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/insurance/hmo/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
//  PPO in Insurance section
export const addPPO = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/ppo/add`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const getPPOList = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/insurance/ppo/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const PPOUpdate = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/insurance/ppo/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
// Authorization  in Insurance section

export const addAuthorization = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/eap/add`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const getAuthorizationList = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/insurance/eap/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const AuthorizationListUpdate = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/insurance/eap/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getInsuranceCompanyList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/company/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.message)
    }
    return response.data
}

export const InsuranceCompanyWithoutPagination = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/insurance/company/listForSettingMenu`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.message)
    }
    return response.data
}

export function useToGetInsurance(params, options = {}) {
    return useQuery(['GET_INSURANCE_LIST'], () => getInsuranceCompanyList(params), options)
}

// Patients Documnets Api

export const addPatientDocumnet = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/document`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getPatientDocumnetList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/document/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const DeletePatientDocumnet = async (params) => {
    const response = await axiosInstance.delete(`${baseURL}/patient/document/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// Patients Progress Notes

export const getPatientProgressNoteList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/filled_progress_note/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getPatientProgressNote = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/filled_progress_note/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// patients treatment plans

export const getPatientTreatmentPlansList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/filled_treatment_plan/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getPatientTreatmentPlans = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/filled_treatment_plan/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// Patient visit history

export const getPatientVisitHistoryList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/visit_history_list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getPatientVisitHistoryDetails = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/visit_history_details`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

//  send form
export const sendFormApi = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/filled_dynamic_form/send_form`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
//  merge patient

export const mergePatient = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/merge`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// Add New payments
export const receivePayment = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/billing/receivePayment`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const billingAppointmentList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/billing/getAppointmentList`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// Patient Payment List /patient/paymentHistory

export const PatientPaymentList = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/patient/paymentHistory`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
